var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 8.75L2.66602 4.66667C2.66602 3.19391 3.85992 2 5.33268 2L9.41602 2M6.66602 14L11.166 14C11.9944 14 12.666 13.3284 12.666 12.5L12.666 6C12.666 5.17157 11.9944 4.5 11.166 4.5L6.66602 4.5C5.83759 4.5 5.16602 5.17157 5.16602 6L5.16602 12.5C5.16602 13.3284 5.83759 14 6.66602 14Z",
    stroke: "#007AFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCode);
export default __webpack_public_path__ + "static/media/copyCode.a403a27de86808dd06ccbb407179227e.svg";
export { ForwardRef as ReactComponent };